import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.target = '_blank';
      anchor.rel = 'noopener nofollow';
      anchor.click();
    }
  };

  return (
    <div className="w-full max-w-md mx-auto">
      <label htmlFor="category-select" className="block text-sm font-semibold text-foreground-700 mb-3">
        Browse Product Categories
      </label>
      <div className="relative">
        <select
          id="category-select"
          onChange={handleChange}
          defaultValue=""
          className="w-full appearance-none bg-background-50 border-2 border-background-300 rounded-xl px-5 py-3.5 pr-12 text-foreground-900 text-sm font-medium cursor-pointer focus:outline-none focus:border-primary-400 transition-colors duration-200"
        >
          <option value="" disabled>Select a category...</option>
          {categories.map((cat) => (
            <option key={cat.seq} value={cat.url}>
              {cat.name}
            </option>
          ))}
        </select>
        <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-foreground-400">
          <i className="ri-arrow-down-s-line text-lg"></i>
        </div>
      </div>
    </div>
  );
}